<template>
  <div class="main-header">
    <div class="header-left-con"><span>经销商后台系统</span></div>
    <div class="header-right-user">
      <Avatar :src="user.app_user_avatar" icon="ios-person"></Avatar>
      <Dropdown trigger="click" style="cursor: pointer;" @on-click="clickUserDropdown">
        <span>{{user.username}}</span>
        <Icon type="arrow-down-b"></Icon>
        <DropdownMenu slot="list">
          <DropdownItem name="loginout">退出登录</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  </div>
</template>
<script>

export default {
  data(){
    return {}
  },
  computed: {
    user () {
      return this.$store.state.user.user
    },
  },
  methods: {
    clickUserDropdown(name) {
      if (name === 'loginout') {
        // 退出登录
        this.loginout()
      }
    },
    loginout(){
      this.$store.commit('userLogout')
      this.$router.push('/login')
    }
  }
}
</script>
<style scoped>
  .header-left-con{
    line-height: 22px;
    margin-left: 25px;
    text-align: left;
    width: 50%;
    color: #FFFFFF;
    font-weight: 800;
    font-size: 18px;
  }
  .header-right-user{
    color: #FFFFFF;
    width: 50%;
    font-size: 14px;
    text-align: right;
    padding-right: 40px;
  }
  .ivu-avatar {
    height: 24px;
    width: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue